// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/pagination/style/index.less
// module id = 1759
// module chunks = 0